<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Gerätebericht konfigurieren"}}</h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
    <div class="form-group">
        <div class="row">
            <div class="col-sm-12">
                <label for="report-name" class="control-label">{{TR "Bezeichnung"}}</label>
                <input
                class="form-control js-report-attr"
                type="text"
                name="name"
                id="report-name"
                value="{{report.name}}"
                maxlength="100"
                ></input>
                {{#if errors.name}}
                <ul class="parsley-errors-list filled" id="js-report-name-error">
                    <li class="parsley-required">{{TR "Berichtname ungültig."}} {{errors.name}}</li>
                </ul>
                {{/if}}
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-sm-12">
                <label for="report-description" class="control-label">{{TR "Beschreibung"}}</label>
                <textarea
                class="form-control js-report-attr"
                name="description"
                id="report-description"
                placeholder="{{TR "Kurze Beschreibung des Berichts"}}"
                maxlength="4000"
                rows="6"
                >{{report.description}}</textarea>
                {{#if errors.description}}
                <ul class="parsley-errors-list filled" id="js-report-description-error">
                    <li class="parsley-required">{{TR "Beschreibung ungültig."}} {{errors.description}}</li>
                </ul>
                {{/if}}
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="checkbox checkbox-primary">
            <input
            id="is-active"
            name="is_active"
            type="checkbox"
            {{#if report.is_active}}checked="checked"{{/if}}
            class="js-report-attr"
            >
            <label for="is-active" class="control-label">{{TR "Der Gerätebericht ist aktiv."}}</label>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-xs-6">
                <label for="report-format" class="control-label">{{TR "Format"}}</label>
            </div>
            <div class="col-xs-6">
                <label for="report-period" class="control-label">{{TR "Zeitspanne"}}</label>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6">
                {{#SELECT report.format}}
                <select name="report-format" class="js-report-attr-redraw-select selectpicker js-report-format" data-style="btn-white form-control">
                    {{#each formats}}
                    <option {{#if disabled}}disabled="disabled"{{/if}} data-icon="{{icon}}" value="{{value}}">{{text}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
            <div class="col-xs-6">
                {{#SELECT report.period}}
                <select name="report-period" class="js-report-attr selectpicker js-report-period" data-style="btn-white form-control">
                    {{#each periods}}
                    <option value="{{value}}">{{text}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
        </div>
        {{#COMPARE report.format '==' 2}}
        <div class="row">
            <div class="col-xs-6">
                <div class="checkbox checkbox-primary">
                    <input
                    id="hide-title-page"
                    name="hide_title_page"
                    type="checkbox"
                    {{#if report.hide_title_page}}checked="checked"{{/if}}
                    class="js-report-attr"
                    >
                    <label for="hide-title-page" class="control-label">{{TR "Titelseite ausblenden"}}</label>
                </div>
                <div class="checkbox checkbox-primary">
                    <input
                    id="hide-description"
                    name="hide_description"
                    type="checkbox"
                    {{#if report.hide_description}}checked="checked"{{/if}}
                    class="js-report-attr"
                    >
                    <label for="hide-description" class="control-label">{{TR "Beschreibung ausblenden"}}</label>
                </div>
            </div>
        </div>
        {{/COMPARE}}
    </div>
    <div class="form-group">
        <div class="row m-t-30 m-b-15">
            <div class="col-xs-12">
                <label for="receiver_list" class="control-label">{{TR "Per E-Mail an Postfach versenden"}}</label>
                {{#SELECT report.receiver_list}}
                <select id="js-mailing-list" name="receiver_list" multiple="multiple" class="js-report-attr js-receiver-other selectpicker" data-style="btn-white form-control">
                    {{#each mailboxes}}
                    <option value="{{id}}">{{name}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
                <small>{{TR "Die Berichte stehen auch ohne E-Mailversand zum Download zur Verfügung."}}</small>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
